import { REPORT_TYPES, ReportSummaryItemApi } from "../api/Reports";
import { useLocation, useNavigate } from "react-router-dom";
import { useFamaFlags } from "../api/FamaFlags";

export function isThreeSixtyReportSummary(report: ReportSummaryItemApi): boolean {
  return report.is_360 === true || report.report_type === REPORT_TYPES.THREE_SIXTY;
}

export function getSummaryPath(
  report: ReportSummaryItemApi,
  v3UiCompletedListWith360: boolean
): string {
  if (v3UiCompletedListWith360 && isThreeSixtyReportSummary(report)) {
    return `/360/${report.report_uuid}/summary`;
  }
  return `/reports/${report.report_uuid}/summary`;
}

const useNavigateToSummaryWithState = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { v3UiCompletedListWith360 } = useFamaFlags();

  const navigateToSummary = (
    reportOrUUID: ReportSummaryItemApi | string
  ) => {
    const state: { originUrl: string; report?: ReportSummaryItemApi } = {
      originUrl: `${location.pathname}${location.search}`,
    };

    const path =
      typeof reportOrUUID === "string"
        ? `/reports/${reportOrUUID}/summary`
        : getSummaryPath(reportOrUUID, v3UiCompletedListWith360);

    navigate(path, {
      state,
    });
  };
  return { navigateToSummary };
};

export default useNavigateToSummaryWithState;
